import config from './config.js'
export default config.dialects || ['esm', 'commonjs']
